export default __webpack_public_path__ + "static/media/firmen.tv.fa11e176.webp";